import React from 'react';
import { facts1980s } from '../data/facts1980s.js';
import { facts1990s } from '../data/facts1990s.js';
import { facts2000s } from '../data/facts2000s.js';
import { facts2010s } from '../data/facts2010s.js';
import { facts2020s } from '../data/facts2020s.js';
import CoverflowSwiper from '../services/CoverflowSwiper.jsx';
import '../styles/minute.css';
import '../styles/carousel.css';

export function FactCarousel() {
  return (
    <>
    <h1>The 1980's</h1>
      <p className='left'>Agricultural work</p>
    <div>
      <br/>
      <CoverflowSwiper images={facts1980s} />
    </div>
    <h1>The 1990's</h1>
      <p className='left'>Wills and trusts</p>
    <div>
      <br/>
      <CoverflowSwiper images={facts1990s} />
    </div>
    <h1>The 2000's</h1>
      <p className='left'>Work and disability</p>
    <div>
      <br/>
      <CoverflowSwiper images={facts2000s} />
    </div>
    <h1>The 2010's</h1>
      <p className='left'>Court processes</p>
    <div>
      <br/>
      <CoverflowSwiper images={facts2010s} />
    </div>
    <h1>The 2020's</h1>
      <p className='left'>More court processes</p>
    <div>
      <br/>
      <CoverflowSwiper images={facts2020s} />
    </div>       
    </>
  );
}

